<template>
  <div>
    <v-text-field
      v-model="data.Records[0].value"
      :rules="rules"
      :label="label"
      :disabled="disabled"
      type="text"
      outlined
      background-color="white"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  props: {
    record: Object,
    label: String,
    init: String,
    rules: Array,
    disabled: Boolean,
  },
  data() {
    return {
      data: {
        Page_id: 0,
        Report_id: null,
        Records: [{ value: "", form_id: 0, form_type: 1 }],
      },
      "--size": "50px",
    };
  },
  async mounted() {
    //初期処理
    this.data.Records[0] = this.record;
    this.data.Records[0].value = this.init;
    this.size = 2;
  },
};
</script>
<style></style>
